import { authFetch } from './auth';

async function parseResponse(res, fallbackError) {
  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(data.error || fallbackError);
  }

  return data;
}

export async function fetchUsers() {
  const res = await authFetch('/api/users');
  return parseResponse(res, '無法取得使用者列表');
}

export async function fetchRoles() {
  const res = await authFetch('/api/roles');
  return parseResponse(res, '無法取得角色列表');
}

export async function createRole(payload) {
  const res = await authFetch('/api/roles', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
  return parseResponse(res, '新增角色失敗');
}

export async function updateRole(roleId, payload) {
  const res = await authFetch(`/api/roles?roleId=${encodeURIComponent(roleId)}`, {
    method: 'PUT',
    body: JSON.stringify(payload)
  });
  return parseResponse(res, '更新角色失敗');
}

export async function createUser(payload) {
  const res = await authFetch('/api/users', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
  return parseResponse(res, '新增使用者失敗');
}

export async function updateUser(userId, payload) {
  const res = await authFetch(`/api/users?userId=${encodeURIComponent(userId)}`, {
    method: 'PUT',
    body: JSON.stringify(payload)
  });
  return parseResponse(res, '更新使用者失敗');
}

export async function fetchPermissions() {
  const res = await authFetch('/api/permissions');
  return parseResponse(res, '無法取得權限列表');
}

export async function createPermission(payload) {
  const res = await authFetch('/api/permissions', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
  return parseResponse(res, '新增權限失敗');
}

export async function updatePermission(permissionId, payload) {
  const res = await authFetch(
    `/api/permissions?permissionId=${encodeURIComponent(permissionId)}`,
    {
      method: 'PUT',
      body: JSON.stringify(payload)
    }
  );
  return parseResponse(res, '更新權限失敗');
}

export async function fetchRolePermissions() {
  const res = await authFetch('/api/role-permissions');
  return parseResponse(res, '無法取得角色權限列表');
}

export async function fetchRolePermissionOptions() {
  const res = await authFetch('/api/role-permissions?type=options');
  return parseResponse(res, '無法取得角色權限選項');
}

export async function syncRolePermissions(roleId, permissionIds) {
  const res = await authFetch(
    `/api/role-permissions?roleId=${encodeURIComponent(roleId)}`,
    {
      method: 'PUT',
      body: JSON.stringify({ permissionIds })
    }
  );
  return parseResponse(res, '更新角色權限失敗');
}
